import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { OutlookWorkspaceService } from '../services/outlook-workspace.service';
import { UserService } from '../services/user.service';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const user = inject(UserService).getUser();

  if (!user) {
    const loginPath = router.parseUrl('/login');
    return new RedirectCommand(loginPath, { skipLocationChange: true });
  }

  inject(OutlookWorkspaceService).restoreSelection();
  return true;
};
